import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  const { t, isRTL } = useLanguage();

  return (
    <div className={`privacy-policy-page ${isRTL ? 'rtl' : 'ltr'}`}>
      <div className="privacy-policy-container">
        <div className="privacy-policy-header">
          <h1>{t('privacyPolicy.title')}</h1>
          <p className="privacy-policy-subtitle">{t('privacyPolicy.subtitle')}</p>
        </div>

        <div className="privacy-policy-content">
          <section className="privacy-section">
            <h2>{t('privacyPolicy.introduction.title')}</h2>
            <p className="privacy-intro">{t('privacyPolicy.introduction.body')}</p>
          </section>

          <section className="privacy-section">
            <h2>{t('privacyPolicy.serviceNature.title')}</h2>
            <p>{t('privacyPolicy.serviceNature.body')}</p>
          </section>

          <section className="privacy-section">
            <h2>{t('privacyPolicy.aiUse.title')}</h2>
            <p>{t('privacyPolicy.aiUse.body')}</p>
          </section>

          <section className="privacy-section">
            <h2>{t('privacyPolicy.documents.title')}</h2>
            <p>{t('privacyPolicy.documents.description')}</p>
            <ul className="privacy-list">
              <li>{t('privacyPolicy.documents.item1')}</li>
              <li>{t('privacyPolicy.documents.item2')}</li>
              <li>{t('privacyPolicy.documents.item3')}</li>
              <li>{t('privacyPolicy.documents.item4')}</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>{t('privacyPolicy.firmMode.title')}</h2>
            <p>{t('privacyPolicy.firmMode.body')}</p>
          </section>

          <section className="privacy-section">
            <h2>{t('privacyPolicy.pdpl.title')}</h2>
            <p>{t('privacyPolicy.pdpl.body')}</p>
          </section>

          <section className="privacy-section">
            <h2>{t('privacyPolicy.liability.title')}</h2>
            <p>{t('privacyPolicy.liability.body')}</p>
          </section>

          <section className="privacy-section">
            <h2>{t('privacyPolicy.prohibitedUse.title')}</h2>
            <p>{t('privacyPolicy.prohibitedUse.description')}</p>
            <ul className="privacy-list">
              <li>{t('privacyPolicy.prohibitedUse.item1')}</li>
              <li>{t('privacyPolicy.prohibitedUse.item2')}</li>
              <li>{t('privacyPolicy.prohibitedUse.item3')}</li>
              <li>{t('privacyPolicy.prohibitedUse.item4')}</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2>{t('privacyPolicy.retention.title')}</h2>
            <p>{t('privacyPolicy.retention.body')}</p>
          </section>

          <section className="privacy-section">
            <h2>{t('privacyPolicy.cookies.title')}</h2>
            <p>{t('privacyPolicy.cookies.body')}</p>
          </section>

          <section className="privacy-section">
            <h2>{t('privacyPolicy.contact.title')}</h2>
            <p>{t('privacyPolicy.contact.body')}</p>
          </section>

          <section className="privacy-section privacy-section--consent">
            <h2>{t('privacyPolicy.consent.title')}</h2>
            <p>{t('privacyPolicy.consent.description')}</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
